module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/G73S39/tc-custom/9781605507507.jpg?1730540547417",
      "alt": "This image is the cover for the book Everything Hinduism Book, The Everything Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Everything Hinduism Book, The Everything Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Yoga. Karma. Reincarnation. Most Americans are familiar with a few basic ideas of Hinduism, but are unfamiliar with the big picture. This beginner’s guide covers the major Hindu thinkers and their philosophies as well as the dharma, the moral way of life that Hindus practice. In a straightforward style, the authors explain the philosophy, gods, texts, and traditions of the world’s third-largest religion, including: the power of karma; Yoga as a path to God; the authority of the Vedas; the development of Jainism, Buddhism, and Sikhism; the legacy of Mohandas Gandhi; Hinduism in popular culture; and more. This guide is stimulating reading for westerners who want to learn the basics of this ancient and mystic religion.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kenneth Schouler, Susai Anthony\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0